import { cn } from '@/lib/utils'
import { XIcon } from 'lucide-react'
import { useState } from 'react'

export const AppBanner = () => {
  const [isClosed, setIsClosed] = useState(false)
  const bannerText = import.meta.env.VITE_BANNER_TEXT

  return (
    <div
      className={cn(
        'sticky top-0 bottom-[100%] z-[1000]',
        isClosed && 'hidden'
      )}
    >
      {!isClosed && bannerText && (
        <div
          className={cn(
            'bg-yellow-100 border-b border-yellow-200 px-3 py-1 text-yellow-800 text-sm',
            'flex items-center justify-between'
          )}
        >
          {bannerText}

          <XIcon
            className="w-4 h-4 cursor-pointer hover:opacity-80 transition-opacity"
            onClick={() => setIsClosed(true)}
          />
        </div>
      )}
    </div>
  )
}
